import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {UserModel} from '../../../models/UserModel';
import {UsersService} from '../service/users.service';
import {ProviderModel} from '../../../models/ProviderModel';
import {RegionModel} from '../../../models/RegionModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';

@Component({
  selector: 'app-edit-users',
  templateUrl: './edit-users.component.html',
  styleUrls: ['./edit-users.component.scss']
})
export class EditUsersComponent extends ProjectConstants implements OnInit, OnDestroy {

  showActions: boolean;
  name: string;
  surname: string;
  role: string;
  mail: string;
  firstStepRegisterFormGroup: FormGroup;
  tablesFormGroup: FormGroup;

  regionListForFilterInSettings: Array<RegionModel> = new Array<RegionModel>();
  contractTypeListForFilterInSettings: Array<ContractTypeModel> = new Array<ContractTypeModel>();
  providerListForFilterInSettings: Array<ProviderModel> = new Array<ProviderModel>();
  localCustomerListForFilterInSettings: Array<LocalCustomerModel> = new Array<LocalCustomerModel>();

  regionsSelectedCode: string;
  localCustomersSelectedCode: string;
  contractTypesSelectedCode: string;
  providersSelectedCode: string;

  localCustomerSelect: LocalCustomerModel;
  providerSelect: ProviderModel;
  regionSelect: RegionModel;
  contractTypeSelect: ContractTypeModel;
  getPageSubscribe: Subscription;
  parameterSubscribe: Subscription;
  saveUser: Subscription;

  usersData: UserModel;
  showLC: boolean;
  showProvider: boolean;
  showRegion: boolean;
  showContractType: boolean;
  isLinear: boolean;
  submitted: boolean;
  userJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private usersService: UsersService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();
    this.submitted = false;
    this.showActions = false;
    this.showProvider = false;
    this.showLC  = false;
    this.showRegion  = false;
    this.showContractType = false;
    this.isLinear = true;

    this.usersData = new UserModel();
    this.providerSelect = new ProviderModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.contractTypeSelect = new ContractTypeModel();

    this.usersData.providerList = [];
    this.usersData.localCustomerList = [];
    this.usersData.regionList = [];
    this.usersData.contractTypeList = [];
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.userJson = params['row'];
      });

    this.usersData = JSON.parse(this.userJson) as UserModel;

    if (this.usersData.regionList.length > 0) {
      this.usersData.regionList.forEach(regionElement => {
        this.regionListForFilterInSettings.push(regionElement);
      });
    }

    if (this.usersData.contractTypeList.length > 0) {
      this.usersData.contractTypeList.forEach(contractTypeElement => {
        this.contractTypeListForFilterInSettings.push(contractTypeElement);
      });
    }

    if (this.usersData.providerList.length > 0) {
      this.usersData.providerList.forEach(providerElement => {
        this.providerListForFilterInSettings.push(providerElement);
      });
    }

    if (this.usersData.localCustomerList.length > 0) {
      this.usersData.localCustomerList.forEach(localCustomerElement => {
        this.localCustomerListForFilterInSettings.push(localCustomerElement);
      });
    }

    this.name = this.usersData.name;
    this.surname = this.usersData.surname;
    this.mail = this.usersData.mail;
    this.role = this.usersData.roleList[0];

    this.firstStepRegisterFormGroup = this.formBuilder.group({
      name: [{value: '', disabled: false}, Validators.required],
      surname: [{value: '', disabled: false}, Validators.required],
      mail: [{value: '', disabled: false}, Validators.required],
      role: [{value: '', disabled: false}, Validators.required]
    });

    this.tablesFormGroup = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      providerCod: [{value: '', disabled: false}, Validators.required],
      regionCod: [{value: '', disabled: false}, Validators.required],
      contractTypeCod: [{value: '', disabled: false}, Validators.required]
    });

    this.firstStepRegisterFormGroup.patchValue({
      name: this.name
    });

    this.firstStepRegisterFormGroup.patchValue({
      surname: this.surname
    });

    this.firstStepRegisterFormGroup.patchValue({
      mail: this.mail
    });

    this.firstStepRegisterFormGroup.patchValue({
      role: this.role
    });

    this.initMultipleProviderCod();

    this.initMultipleLocalCustomerCod();

    this.initMultipleRegionCod();

    this.initMultipleContractTypeCod();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.USERS]);
  }

  save() {
    this.submitted = true;
    if (this.firstStepRegisterFormGroup.valid) {
      this.usersData.name = this.firstStepRegisterFormGroup.value.name;
      this.usersData.surname = this.firstStepRegisterFormGroup.value.surname;
      this.usersData.mail = this.firstStepRegisterFormGroup.value.mail;
      this.usersData.idRole = this.ROLES_LIST.indexOf(this.firstStepRegisterFormGroup.value.role) + 1;
      event.preventDefault();
      this.loaderService.display(true);
      this.saveUser = this.usersService.update(this.usersService.baseUrl, this.usersData)
        .subscribe(
          (result: any) => {
            toastr.success('User was edited with success', 'Success');
            this.loaderService.display(false);
            this.router.navigate([this.LINKS.USERS]);
          },
          error => {
            toastr.error('User was not edited', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveUser) {
      this.saveUser.unsubscribe();
    }
    if (this.parameterSubscribe) {
      this.parameterSubscribe.unsubscribe();
    }
  }

  get f() { return this.firstStepRegisterFormGroup.controls; }

  getElementSelectedLC($event) {
    const localCustomerSelected = $event.row;

    const index = this.usersData.localCustomerList.findIndex(x => x.id === localCustomerSelected.id);
    if (index === -1) {
      this.usersData.localCustomerList.push(localCustomerSelected);
    } else {
      this.usersData.localCustomerList.splice(index, 1);
    }

    this.localCustomerListForFilterInSettings = new Array<LocalCustomerModel>();

    for (let _i = 0; _i < this.usersData.localCustomerList.length; _i++) {
      this.localCustomerListForFilterInSettings.push(this.usersData.localCustomerList[_i]);
    }

    this.initMultipleLocalCustomerCod();
  }

  getElementSelectedProvider($event) {
    const providerSelected = $event.row;
    const index = this.usersData.providerList.findIndex(x => x.id === providerSelected.id);
    if (index === -1) {
      this.usersData.providerList.push(providerSelected);
    } else {
      this.usersData.providerList.splice(index, 1);
    }

    this.providerListForFilterInSettings = new Array<ProviderModel>();

    for (let _i = 0; _i < this.usersData.providerList.length; _i++) {
      this.providerListForFilterInSettings.push(this.usersData.providerList[_i]);
    }

    this.initMultipleProviderCod();
  }

  getElementSelectedRegion($event) {
    const regionSelected = $event.row;
    const index = this.usersData.regionList.findIndex(x => x.id === regionSelected.id);
    if (index === -1) {
      this.usersData.regionList.push(regionSelected);
    } else {
      this.usersData.regionList.splice(index, 1);
    }

    this.regionListForFilterInSettings = new Array<RegionModel>();

    for (let _i = 0; _i < this.usersData.regionList.length; _i++) {
      this.regionListForFilterInSettings.push(this.usersData.regionList[_i]);
    }

    this.initMultipleRegionCod();
  }

  getElementSelectedContractType($event) {
    const contractTypeSelected = $event.row;

    const index = this.usersData.contractTypeList.findIndex(x => x.id === contractTypeSelected.id);
    if (index === -1) {
      this.usersData.contractTypeList.push(contractTypeSelected);
    } else {
      this.usersData.contractTypeList.splice(index, 1);
    }

    this.contractTypeListForFilterInSettings = new Array<ContractTypeModel>();

    for (let _i = 0; _i < this.usersData.contractTypeList.length; _i++) {
      this.contractTypeListForFilterInSettings.push(this.usersData.contractTypeList[_i]);
    }

    this.initMultipleContractTypeCod();
  }

  resetLc() {
    this.tablesFormGroup.patchValue({
      localCustomerCod: ''
    });

    this.showLC = false;
    this.localCustomerListForFilterInSettings = new Array<LocalCustomerModel>();
    this.usersData.localCustomerList = new Array<LocalCustomerModel>();
    this.localCustomersSelectedCode = '';
  }

  resetProvider() {
    this.tablesFormGroup.patchValue({
      providerCod: ''
    });

    this.showProvider = false;
    this.providerListForFilterInSettings = new Array<ProviderModel>();
    this.usersData.providerList = new Array<ProviderModel>();
    this.providersSelectedCode = '';
  }

  resetRegion() {
    this.tablesFormGroup.patchValue({
      regionCod: ''
    });

    this.showRegion = false;
    this.regionListForFilterInSettings = new Array<RegionModel>();
    this.usersData.regionList = new Array<RegionModel>();
    this.regionsSelectedCode = '';
  }

  resetContractType() {
    this.tablesFormGroup.patchValue({
      contractTypeCod: ''
    });

    this.showContractType = false;
    this.contractTypeListForFilterInSettings = new Array<ContractTypeModel>();
    this.usersData.contractTypeList = new Array<ContractTypeModel>();
    this.contractTypesSelectedCode = '';
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleContractType() {
    this.showContractType = !this.showContractType;
  }

  initMultipleProviderCod() {
    this.providersSelectedCode = '';

    for (let _i = 0; _i < this.providerListForFilterInSettings.length - 1; _i++) {
      this.providersSelectedCode = this.providersSelectedCode + this.providerListForFilterInSettings[_i].description + ', ';
    }

    if (this.providerListForFilterInSettings.length > 0) {
      this.providersSelectedCode =
        this.providersSelectedCode +
        this.providerListForFilterInSettings[this.providerListForFilterInSettings.length - 1].description;
    }

    this.tablesFormGroup.patchValue({
      providerCod: this.providersSelectedCode
    });
  }

  initMultipleLocalCustomerCod() {
    this.localCustomersSelectedCode = '';

    for (let _i = 0; _i < this.localCustomerListForFilterInSettings.length - 1; _i++) {
      this.localCustomersSelectedCode = this.localCustomersSelectedCode + this.localCustomerListForFilterInSettings[_i].description + ', ';
    }

    if (this.localCustomerListForFilterInSettings.length > 0) {
      this.localCustomersSelectedCode =
        this.localCustomersSelectedCode
        + this.localCustomerListForFilterInSettings[this.localCustomerListForFilterInSettings.length - 1].description;
    }

    this.tablesFormGroup.patchValue({
      localCustomerCod: this.localCustomersSelectedCode
    });
  }

  initMultipleRegionCod() {
    this.regionsSelectedCode = '';

    for (let _i = 0; _i < this.regionListForFilterInSettings.length - 1; _i++) {
      this.regionsSelectedCode = this.regionsSelectedCode + this.regionListForFilterInSettings[_i].description + ', ';
    }

    if (this.regionListForFilterInSettings.length > 0) {
      this.regionsSelectedCode =
        this.regionsSelectedCode +
        this.regionListForFilterInSettings[this.regionListForFilterInSettings.length - 1].description;
    }

    this.tablesFormGroup.patchValue({
      regionCod: this.regionsSelectedCode
    });
  }

  initMultipleContractTypeCod() {
    this.contractTypesSelectedCode = '';

    for (let _i = 0; _i < this.contractTypeListForFilterInSettings.length - 1; _i++) {
      this.contractTypesSelectedCode = this.contractTypesSelectedCode + this.contractTypeListForFilterInSettings[_i].description + ', ';
    }

    if (this.contractTypeListForFilterInSettings.length > 0) {
      this.contractTypesSelectedCode =
        this.contractTypesSelectedCode +
        this.contractTypeListForFilterInSettings[this.contractTypeListForFilterInSettings.length - 1].description;
    }

    this.tablesFormGroup.patchValue({
      contractTypeCod: this.contractTypesSelectedCode
    });
  }
}

